import type { PropsWithChildren } from 'react';
import { Dropdown } from 'react-bootstrap';

type DropdownItemProps = {
  className?: string;
  purpose?: 'item' | 'title';
  state?: 'active' | 'disabled';
  href?: string;
  onClick?: () => void;
};

export const DropdownItem = ({
  className,
  purpose = 'item',
  state,
  href,
  children,
  onClick,
}: PropsWithChildren<DropdownItemProps>) =>
  purpose === 'item' ? (
    <Dropdown.Item
      className={className}
      active={state === 'active'}
      disabled={state === 'disabled'}
      href={href}
      onClick={onClick}
    >
      {children}
    </Dropdown.Item>
  ) : (
    <Dropdown.Header className={className}>{children}</Dropdown.Header>
  );
